import Validators from "./API_Validators.js";

export default {
  isActive: Validators.isActive,
  isExist: Validators.isExist,
  isStatic: Validators.isStatic,
  isValid: Validators.isValid
}